import React from "react"

import Layout from "../components/allstar/layout"
import SectionHero from "../components/allstar/faq/section-hero"
import SectionBody from "../components/allstar/faq/section-body"
import { graphql } from "gatsby"

const FAQPage = props => {
  return (
    <Layout
      location={props.location}
      title={"Frequently Asked Questions (FAQ)"}
    >
      <SectionHero data={props.data} />
      <SectionBody data={props.data} />
    </Layout>
  )
}

export default FAQPage

export const query = graphql`
  query faqPage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
